import { CloseOutlineIcon } from "../icon/CloseOutlineIcon";

interface Props {
  imageUrl: string;
  closeModal: () => void;
}

export const PartnerBusinessCertificateModal: React.FC<Props> = ({
  imageUrl,
  closeModal,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 gap-[16px] bg-grayscale-contrast-50">
      <div className="flex overflow-auto max-w-full max-h-full">
        <img
          src={imageUrl}
          alt="business-certificate"
          className="max-w-[90%] max-h-[90%] object-contain"
        />
        <div
          className="flex items-center cursor-pointer justify-center w-[48px] h-[48px]"
          onClick={closeModal}
        >
          <CloseOutlineIcon color="text-primary-white" />
        </div>
      </div>
    </div>
  );
};
